import { ServiceTransportWithExportImport } from '@tencent/s2-client-vue-lib';
import { appModule, ISceneMode } from '@/store/modules/ModuleApp';
import axios from 'axios';
import Vue from 'vue';

/**
 * 导入导出接口
 *
 * @class ServiceCommon
 * @extends {ServiceAdapter}
 */
export class ServiceImportAndExport extends ServiceTransportWithExportImport {
	/**
	 * GET方式导出
	 *
	 * @param {string} url
	 * @param {{}} params
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceImportAndExport
	 */
	public async exportGet(url: string, params: any = {}): Promise<any> {
		// const res: any = await this.get(url, { params });
		const res: any = await this.get(url, { params, responseType: 'blob' });
		// console.log(res, 'res...');
		if (res && !res.data && res.message) {
			Vue.prototype.$message({
				message: res.message,
				type: 'error',
				duration: 1500
			});
		} else {
			this.executeDownload(res);
		}

		return res;
	}

	/**
	 * POST方式导出
	 *
	 * @param {string} url
	 * @param {*} data
	 * @param {*} [params={}]
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceImportAndExport
	 */
	public async exportPost(url: string, data: any, params: any = {}): Promise<any> {
		const res: any = await this.post(url, data, { headers: { transformByte: true }, params, responseType: 'blob', showLogs: true });
		// console.log('res...', res);

		if (res && !res.data && res.message) {
			Vue.prototype.$message({
				message: res.message,
				type: 'error',
				duration: 1500
			});
		} else {
			if (res && res.data && res.data.type === 'application/json') {
				// 兼容有正确结构返回，但返回了错误格式情况
				Vue.prototype.$message({
					message: '导出异常，请检查导入或添加数据内容',
					type: 'error',
					duration: 1500
				});
			} else {
				this.executeDownload(res);
			}
		}

		return res;
	}

	/**
	 * GET方式导出 预览文件
	 *
	 * @param {string} url
	 * @param {{}} params
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceImportAndExport
	 */
	public async exportGetpdf(url: string, params: any = {}): Promise<any> {
		const res: any = await this.get(url, { headers: { transformByte: true }, params, responseType: 'blob', showLogs: true });

		// 新标签打开
		const newUrl = window.URL.createObjectURL(res.data);
		window.open(newUrl);

		return res;
	}
}
